import { useState } from 'react';
import useFetch from 'use-http';

import { API_ROUTES } from '../../constants';
import { TAPIResponseUploadImgParams } from './upload-img-to-s3.types'


export const useAPIUploadImgToS3 = (): TAPIResponseUploadImgParams => {
  const [responseData, setResponseData] = useState<any>({
    data: null,
    error: undefined,
    loaded: undefined,
    loading: false,
  });
  const { get, response } = useFetch(API_ROUTES.COMMON);

  async function uploadImgToS3(file:any): Promise<void> {
    setResponseData({
      data: null,
      error: undefined,
      loaded: undefined,
      loading: true,
    })

    const data = await get(`/upload-img-params`);

    if (response.ok && data) {
      const formData = new FormData();
      for ( const key in data.data.fields ) {
          formData.append(key, data.data.fields[key]);
      }

      const keyPamams = data?.data?.fields?.key.split('/')[2]?.split('$')[0];
      const randomName =  `${Math.random().toString(36).replace('0.', 'file_')+ Math.random().toString(18).replace('0.', '')}.${file?.name.split('.')[file?.name.split('.').length - 1].toLowerCase()}`
      const newFaleName  = `${keyPamams}${randomName}`

      if(file) {
        formData.append('file', file, randomName);
      }

      try {
        await fetch(data.data.url,   {
          method: 'POST',
          body: formData
        });

        setResponseData({
          ...responseData,
          loading: false,
          data: newFaleName,
          loaded: true,
        });

      } catch (error) {
        setResponseData({
          ...responseData,
          data: null,
          loading: false,
          error: true,
          loaded: true,
        });

      }
    }
  }

  return {
    loading: responseData.loading,
    error: responseData.error,
    data: responseData.data,
    loaded: responseData.loaded,
    uploadImgToS3,
  };
};
